import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/TermTypeService";
const store = {};
const mutations = {

    SET_TERM_TYPE_LIST(state, posts) {
        state.termTypeList = posts;
        state.termTypeListIsLoading = false;
    },
    GET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.termTypeDetail = posts.data;
            state.termTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.termTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
};
const state = {
    termListIsLoading: false,
    termList: [],
    termDetail: {},
    termDetailChanged: false
};
const getters = {};
const actions = {

    getTermTypeList({ commit }) {
        state.termTypeListIsLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_TERM_TYPE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getTermTypeDetail({ commit }, data) {
        state.termTypeListIsLoading = true;
        var formData = new FormData();
        formData.append("tetID", data.tetId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    saveTermTypeDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.termTypeDetail));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }
            });
    }
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}